
import React from 'react';

interface ForYouInterestTagProps {
    text: string;
}

export const ForYouInterestTag: React.FC<ForYouInterestTagProps> = ({ text }) => {
    return (
        <div className="flex py-2 px-3 items-center gap-2.5 rounded border-[0.5px] border-secondary-300 bg-secondary-300/10">
            <span className="text-secondary-500 font-grotesk text-xs font-medium leading-4">
                {text}
            </span>
        </div>
    );
};
